import React from 'react';
import { CTAButton, CHECKOUT_URL } from './ui/CTAButton';
export function BonusSection() {
  return <section className="w-full bg-white py-16" data-id="element-34">
      <div className="max-w-3xl mx-auto px-4" data-id="element-35">
        <div className="text-center mb-12" data-id="element-36">
          <h2 className="text-4xl md:text-5xl font-black text-red-600 mb-4 uppercase tracking-tight" data-id="element-37">
            🎁 BONOS EDUCATIVOS
          </h2>
          <div className="inline-block bg-yellow-400 text-black font-black text-2xl px-6 py-2 rounded-full transform -rotate-2" data-id="element-38">
            GRATIS HOY
          </div>
        </div>

        <div className="space-y-12" data-id="element-39">
          {/* Bono 1 */}
          <div className="bg-gray-50 rounded-2xl p-6 md:p-8 border-2 border-dashed border-yellow-400 relative" data-id="element-40">
            <div className="absolute -top-4 -right-4 bg-red-600 text-white font-bold px-4 py-1 rounded-full transform rotate-12 shadow-lg" data-id="element-41">
              GRATIS
            </div>
            <h3 className="text-2xl font-black mb-2" data-id="element-42">
              🎁 Bono #1 — Aprende Cards
            </h3>
            <p className="text-lg text-gray-700 mb-4" data-id="element-43">
              Tarjetas educativas visuales para aprender conceptos básicos de
              forma divertida.
            </p>
            <div className="flex flex-col md:flex-row items-center gap-6" data-id="element-44">
              <a href={CHECKOUT_URL} className="w-full md:w-1/2 block transform transition hover:scale-105" data-id="element-45">
                <img src="https://cdn.magicpatterns.com/uploads/2EWKb6TzZJdUUrpGRgP8cL/Bono_1_mockup.png" alt="Aprende Cards" className="w-full rounded-xl shadow-md" data-id="element-46" />
              </a>
              <div className="w-full md:w-1/2 text-center md:text-left" data-id="element-47">
                <p className="text-gray-500 line-through text-xl" data-id="element-48">
                  Valor: USD $19
                </p>
                <p className="text-3xl font-black text-green-600" data-id="element-49">
                  HOY: GRATIS
                </p>
              </div>
            </div>
          </div>

          {/* Bono 2 */}
          <div className="bg-gray-50 rounded-2xl p-6 md:p-8 border-2 border-dashed border-yellow-400 relative" data-id="element-50">
            <div className="absolute -top-4 -right-4 bg-red-600 text-white font-bold px-4 py-1 rounded-full transform rotate-12 shadow-lg" data-id="element-51">
              GRATIS
            </div>
            <h3 className="text-2xl font-black mb-2" data-id="element-52">
              🎁 Bono #2 — Mindfulness para niños
            </h3>
            <p className="text-lg text-gray-700 mb-4" data-id="element-53">
              Actividades simples que ayudan a los niños a desarrollar calma,
              atención y regulación emocional.
            </p>
            <div className="flex flex-col md:flex-row items-center gap-6" data-id="element-54">
              <a href={CHECKOUT_URL} className="w-full md:w-1/2 block transform transition hover:scale-105" data-id="element-55">
                <img src="https://cdn.magicpatterns.com/uploads/b8r9JvqodqbWcKgWHro3d5/Bono_2_Mockup.png" alt="Mindfulness para niños" className="w-full rounded-xl shadow-md" data-id="element-56" />
              </a>
              <div className="w-full md:w-1/2 text-center md:text-left" data-id="element-57">
                <p className="text-gray-500 line-through text-xl" data-id="element-58">
                  Valor: USD $15
                </p>
                <p className="text-3xl font-black text-green-600" data-id="element-59">
                  HOY: GRATIS
                </p>
              </div>
            </div>
          </div>

          {/* Bono 3 */}
          <div className="bg-gray-50 rounded-2xl p-6 md:p-8 border-2 border-dashed border-yellow-400 relative" data-id="element-60">
            <div className="absolute -top-4 -right-4 bg-red-600 text-white font-bold px-4 py-1 rounded-full transform rotate-12 shadow-lg" data-id="element-61">
              GRATIS
            </div>
            <h3 className="text-2xl font-black mb-2" data-id="element-62">
              🎁 Bono #3 — Aprendo vocales coloreando
            </h3>
            <p className="text-lg text-gray-700 mb-4" data-id="element-63">
              Actividades diseñadas para aprender las vocales mientras los niños
              colorean y juegan.
            </p>
            <div className="flex flex-col md:flex-row items-center gap-6" data-id="element-64">
              <a href={CHECKOUT_URL} className="w-full md:w-1/2 block transform transition hover:scale-105" data-id="element-65">
                <img src="https://cdn.magicpatterns.com/uploads/faqZ7A7GzKEjrRPSUoD3GP/Bono_3_Mockup.png" alt="Aprendo vocales coloreando" className="w-full rounded-xl shadow-md" data-id="element-66" />
              </a>
              <div className="w-full md:w-1/2 text-center md:text-left" data-id="element-67">
                <p className="text-gray-500 line-through text-xl" data-id="element-68">
                  Valor: USD $12
                </p>
                <p className="text-3xl font-black text-green-600" data-id="element-69">
                  HOY: GRATIS
                </p>
              </div>
            </div>
          </div>

          {/* Bono 4 */}
          <div className="bg-gray-50 rounded-2xl p-6 md:p-8 border-2 border-dashed border-yellow-400 relative" data-id="element-70">
            <div className="absolute -top-4 -right-4 bg-red-600 text-white font-bold px-4 py-1 rounded-full transform rotate-12 shadow-lg" data-id="element-71">
              GRATIS
            </div>
            <h3 className="text-2xl font-black mb-2" data-id="element-72">
              🎁 Bono #4 — Tabla de recompensas
            </h3>
            <p className="text-lg text-gray-700 mb-4" data-id="element-73">
              Una herramienta práctica para motivar a los niños y reforzar
              hábitos positivos.
            </p>
            <div className="flex flex-col md:flex-row items-center gap-6" data-id="element-74">
              <a href={CHECKOUT_URL} className="w-full md:w-1/2 block transform transition hover:scale-105" data-id="element-75">
                <img src="https://cdn.magicpatterns.com/uploads/7F1s6jVDFtAyzJZkaDDk8H/Bono_4_Mockup.png" alt="Tabla de recompensas" className="w-full rounded-xl shadow-md" data-id="element-76" />
              </a>
              <div className="w-full md:w-1/2 text-center md:text-left" data-id="element-77">
                <p className="text-gray-500 line-through text-xl" data-id="element-78">
                  Valor: USD $10
                </p>
                <p className="text-3xl font-black text-green-600" data-id="element-79">
                  HOY: GRATIS
                </p>
              </div>
            </div>
          </div>

          {/* Bono 5 */}
          <div className="bg-gray-50 rounded-2xl p-6 md:p-8 border-2 border-dashed border-yellow-400 relative" data-id="element-80">
            <div className="absolute -top-4 -right-4 bg-red-600 text-white font-bold px-4 py-1 rounded-full transform rotate-12 shadow-lg" data-id="element-81">
              GRATIS
            </div>
            <h3 className="text-2xl font-black mb-2" data-id="element-82">
              🎁 Bono #5 — Plantillas para plastilina
            </h3>
            <p className="text-lg text-gray-700 mb-4" data-id="element-83">
              Plantillas creativas para jugar con plastilina y estimular la
              creatividad y la motricidad fina.
            </p>
            <div className="flex flex-col md:flex-row items-center gap-6" data-id="element-84">
              <a href={CHECKOUT_URL} className="w-full md:w-1/2 block transform transition hover:scale-105" data-id="element-85">
                <img src="https://cdn.magicpatterns.com/uploads/1DzA2ztkMq3yFD3cAayVBP/WhatsApp_Image_2026-03-14_at_12.05.35.jpg" alt="Plantillas para plastilina" className="w-full rounded-xl shadow-md" data-id="element-86" />
              </a>
              <div className="w-full md:w-1/2 text-center md:text-left" data-id="element-87">
                <p className="text-gray-500 line-through text-xl" data-id="element-88">
                  Valor: USD $10
                </p>
                <p className="text-3xl font-black text-green-600" data-id="element-89">
                  HOY: GRATIS
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16" data-id="element-90">
          <CTAButton data-id="element-91" />
        </div>
      </div>
    </section>;
}